import useExpenses from './useExpenses';

export default useExpenses;
